<template>
  <div class="resume">
    <div class="resume__wrap">
      <div class="resume__rooms">
        <p class="semibold">La tua scelta:</p>
        <resume-item>
          <template v-slot:label_sx><span class="resume__rooms-label semibold">1x</span></template>
          <template v-slot:label_dx><span class="resume__rooms-label resume__rooms-label--rooms">{{ property_data.room.name }}</span></template>
        </resume-item>
      </div>

      <div class="resume__included">
        <resume-item v-for="(inc, inc_index) in costs.included" :key="_uid+'included'+inc_index">
          <template v-slot:icon v-if="inc.tooltip !== ''">
            <vb-icon
              class="ml-1"
              :name="'info'"
              :color="sass('gray-500')"
              :size="13"
              v-b-popover.hover.left="inc.tooltip"
            />
          </template>
          <template v-slot:label_sx>{{ inc.title }}</template>
          <template v-slot:label_dx>{{ '€ ' + inc.data }}</template>
        </resume-item>
      </div>

      <resume-item class="resume__total">
        <template v-slot:label_sx>Totale</template>
        <template v-slot:label_dx>{{ '€ ' + property_data.live_price }}</template>
      </resume-item>

      <credit-alert
        v-if="activate_credit_alert && get_availability(property_data.live_price).show_credit_alert"
        :color="'danger'"
        class="resume__credit"
      />

      <div class="resume__excluded" v-if="costs.excluded.condition">
        <p class="semibold">Da pagare in struttura:</p>
        <div  v-for="(exc, exc_index) in Object.keys(costs.excluded.data)" :key="_uid+'excluded'+exc_index">
          <resume-item :set_get_fees="fees = get_fees(exc)">
            <template v-slot:icon v-if="fees.tooltip !== ''">
              <vb-icon
                class="ml-1"
                :name="'info'"
                :color="sass('gray-500')"
                :size="13"
                v-b-popover.hover.left="fees.tooltip"
              />
            </template>
            <template v-slot:label_sx>{{ fees.label }}</template>
            <template v-slot:label_dx>{{ '€ ' + costs.excluded.data[exc] }}</template>
          </resume-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { subtract, number, round } from 'mathjs'
import { markup } from '@liveeps/utilities'
import { get_fees } from '@liveeps/resources'
import ResumeItem from "@liveeps/components/blocks/resume/resume-item"
import CreditAlert from "@components/atoms/credit-alert"

export default {
  name: 'resume',

  components: {
    'resume-item': ResumeItem,
    'credit-alert': CreditAlert,
  },

  props: {
    property_data: Object,
    activate_credit_alert: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
    }
  },

  computed: {

    costs() {
      const { total, marketing_fee, fees } = this.property_data.rate.pricing

      return {
        included: [
          {
            condition: total && total !== '',
            title: 'Costo notti',
            data: round(subtract(number(total), number(marketing_fee))),
            tooltip: '',
          },
          {
            condition: marketing_fee && marketing_fee !== '',
            title: 'Tasse ed oneri',
            data: marketing_fee,
            tooltip: 'Questo addebito include gli importi stimati che il fornitore dei servizi di viaggio (ad esempio hotel, società di autonoleggio) paga in forma di tasse e/o le tasse che paghiamo alle autorità fiscali sulla tua prenotazione (incluse, a titolo esemplificativo, le imposte sulle vendite, di soggiorno o sul valore aggiunto). Può anche includere eventuali importi a noi addebitati per le tariffe resort, i supplementi per le pulizie e altre spese e/o un costo che noi, il fornitore dell\'hotel e/o il sito su cui hai prenotato tratteniamo come parte del compenso per i nostri servizi, che varia in base a fattori quali la posizione, l\'importo e la modalità di prenotazione. Per maggiori informazioni, consulta i termini e le condizioni.',
          },
          {
            condition: total && total !== '',
            title: 'Gestione e assistenza',
            data: markup(total).markup,
            tooltip: 'Questi costi includono tasse e costi di gestione della prenotazione, oltre alla nostra assistenza clienti sempre a portata di click.',
          }
        ],
        excluded: {
          condition: Boolean(fees),
          title: 'Da pagare in struttura',
          data: fees,
          tooltip: ''
        }
      }
    }
  },

  created() {
    this.get_fees = get_fees
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .resume {
    margin-bottom: $grid-gutter-width;

    @media print {
      border-radius: $border-radius-lg * 2;
      border: 1px solid $gray-300;
      margin-top: $grid-gutter-width;
    }

    &__wrap {
      background-color: $white;
      border-radius: $border-radius-lg * 2;
      padding: $grid-gutter-20;
      overflow: hidden;

      @include media-breakpoint-up(xl){
        overflow: auto;
      }

      ::v-deep {
        .custom-link {
          a {
            display: block;
          }
        }
      }
    }

    &__rooms {
      padding-bottom: $grid-gutter-width / 6;
      border-bottom: 1px solid $gray-400;
      margin-bottom: $grid-gutter-width / 6;

      &-label {

        &--rooms {
          margin-bottom: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-left: $grid-gutter-width / 3;
        }
      }
    }

    &__total {
      padding-top: $grid-gutter-width / 3;
      margin-top: $grid-gutter-width / 3;
      border-top: 1px solid $gray-400;
      font-weight: $vb-font-weight-semibold;
    }

    &__excluded {
      margin-top: $grid-gutter-width;
    }

    &__credit {
      display: flex;
      justify-content: flex-end;
    }
  }

</style>